
import React from 'react';
import {Modal2} from "../modal";
import {TextLoading} from "../../funcs/utils";
import { adminDeleteUser } from "./actions";

const DeleteUserModal = props => {

  const component = props.component;
  const name = props.name;

  const container_style = {
    width: "30rem",
  }
  const on_close = () => {
    component.setState({
      show_delete_user_dialog: null,
    })
  }
  const loading = component.state.dialog_exec;
  const delete_user = () => {
    component.setState({
      dialog_exec: true,
    });
    adminDeleteUser(component.props.token, props.username)
      .then(() => {
        component.setState({
          dialog_exec: false,
          show_delete_user_dialog: null,
        })
        component.maybeLoad(true);
      })
  }

  const button_list = [
    {
      label: "Cancel",
      cb: on_close,
    },
    {
      label: (
        <TextLoading
          loading={loading}
          label={"Delete"}/>
      ),
      cb: delete_user,
    }
  ]
  const header_style = {
    padding: "0.5rem",
  }
  const header = "Delete User";
  return (
    <Modal2
      container_style={container_style}
      header_style={header_style}
      header={header}
      buttonList={button_list}>
      <div>
        Delete {name}, <br/>{props.username} ?
      </div>
    </Modal2>
  )
}

export { DeleteUserModal };
